<template>
    <div class="digital_yuan_container">
        <img :src="imgUrl" alt="" class="title">
        <img alt="" class="digital_yuan_logo" src="../../assets/images/postalNewCustomer/digital_yuan.png">
    </div>
</template>

<script>
const prizes = {
    'a8638ea8-2e05-4e00-a7ca-b4f7f2a397df': require('@/assets/images/postalNewCustomer/6.png'),
    'c300db21-66ce-41b3-8332-35b8d9690a29': require('@/assets/images/postalNewCustomer/8.png'),
    '524bdd29-b582-4bb5-9b55-95af5e1b9824': require('@/assets/images/postalNewCustomer/88.png'),
    '52bbc48b-61dc-4938-bf01-b80007310a63': require('@/assets/images/postalNewCustomer/18.png'),
}

export default {
    name: "DigitalYuanNumber",
    props: {
        id: String
    },
    computed: {
        imgUrl() {
            return this.id ? prizes[this.id] : undefined
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./components/function";

.digital_yuan_container {
    width: 100%;
    position: relative;

    .title {
        position: absolute;
        // width: 100%;
        height: pxvw(54);
        top: pxvw(100);
        left: 50%;
        transform: translateX(-50%);
    }

    .digital_yuan_logo {
        // width: 100%;
        width: pxvw(514);
        margin: 0 auto;
        display: block;
    }
}
</style>
